var map = {
	"./color-palette.svg": "3e2f",
	"./headphone.svg": "3c54",
	"./list.svg": "8ac3",
	"./media.svg": "89ab",
	"./shield.svg": "6526",
	"./upload.svg": "9d56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "805e";